import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { countOrZero, nullableBoolean, nullableString } from '../utils/wire-value-utils';
import { InvitationEmailStatus } from './invitation-email-status.model';

/**
 * An organization invitation as the admin routes return it (hub `toAdminOrgInvitationResponse`,
 * `ADMIN_ORG_INVITATION_READABLE`). The hub never returns the invitation token, metadata or actor ids.
 * `emailError` is static hub text, never the mail provider's message.
 */
export class PendingInvitation extends Base {
  organizationId?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  role: number;
  isAccepted?: boolean | null;
  isCancelled?: boolean | null;
  /** ISO timestamps as sent by the hub. */
  expiresAt?: string | null;
  lastResentAt?: string | null;
  emailSentAt?: string | null;
  resendCount: number;
  emailStatus?: InvitationEmailStatus | null;
  emailError?: string | null;
  inviterName?: string | null;
  inviterEmail?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.organizationId = nullableString(source['organizationId']);
    this.email = nullableString(source['email']);
    this.firstName = nullableString(source['firstName']);
    this.lastName = nullableString(source['lastName']);
    this.role = countOrZero(source['role']);
    this.isAccepted = nullableBoolean(source['isAccepted']);
    this.isCancelled = nullableBoolean(source['isCancelled']);
    this.expiresAt = nullableString(source['expiresAt']);
    this.lastResentAt = nullableString(source['lastResentAt']);
    this.emailSentAt = nullableString(source['emailSentAt']);
    this.resendCount = countOrZero(source['resendCount']);
    this.emailStatus = nullableString(source['emailStatus']) as InvitationEmailStatus | null | undefined;
    this.emailError = nullableString(source['emailError']);
    this.inviterName = nullableString(source['inviterName']);
    this.inviterEmail = nullableString(source['inviterEmail']);
  }
}
